import {DefaultModule, registerModule} from "../../builder/DashboardConfigServiceRegistry";
import {SectionService} from "../../Section";
import React, {ReactNode} from "react";
import Home from "./Home";

registerModule('AsanaTurner', new class extends DefaultModule {

  overrideUIStrings() {
    return {
      "Asset Management": "Portfolio Management",
      "Borrower": "Portfolio",
      "Loan": "Financing Partner",
      "Upcoming Loan Payments": "Upcoming Payments to Financing Partner",
      "Borrower Summary": "Portfolio Summary"
    }
  }


  overrideDashboardSections(sectionService: SectionService) {

    //Adds home page
    sectionService.addSection({
      key: 'home',
      title: 'Home',
      order: -10,
      render: () => <Home />
    });

    sectionService.setHomeSection('home')

    return sectionService;
  }


})